export default __webpack_public_path__ + "static/media/kalahasti idol.6c7017d2.jpg";